<template>
  <HelloWorld msg="Welcome to Your Vue.js App" />
</template>

<script>
import HelloWorld from "./views/HelloWorld.vue";

export default {
  name: "app",
  components: {
    HelloWorld,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700;800;900&display=swap");
/* body {
  font-family: "Nunito";
  background: #f6f7f8;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 10vh;
  color: #051b2c;
} */
/* .container {
  background-color: #ffffff;
  padding: 24px 24px 26px 24px;
  border-radius: 8px;
  max-width: 438px;
  flex-shrink: 0;
  box-shadow: 0px 3px 4px -1px rgba(5, 27, 44, 0.08) 0px 1px 8px -1px
    rgba(5, 27, 44, 0.12);
} */
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
button {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #4346ce;
  color: #ffffff;
  border-radius: 4px;
  border: 1px solid #3a3db3;
  font-size: 16px;
  box-shadow: 0px 1px 1px 0px rgba(5, 27, 44, 0.16),
    0px 2px 0px 0px rgba(255, 255, 255, 0.05) inset;
}
button:hover,
button:focus {
  background: #3a3db3;
}
button:focus {
  box-shadow: 0px 1px 1px 0px rgba(5, 27, 44, 0.16),
    0px 2px 0px 0px rgba(255, 255, 255, 0.05) inset;
} */
</style>
